/**
 * Local saves for standalone mode — uses localStorage.
 * Mirrors the API save format so the game code works identically.
 */

const STORAGE_PREFIX = 'game_saves_';

export function listSaves(teamId) {
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${teamId}`);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function putSave(teamId, saveData) {
  const saves = listSaves(teamId);
  const idx = saves.findIndex(
    (s) => s.saveType === saveData.saveType && s.slot === saveData.slot
  );
  const now = new Date().toISOString();
  const entry = {
    ...saveData,
    updatedAt: now
  };
  if (idx >= 0) {
    saves[idx] = { ...saves[idx], ...entry };
  } else {
    entry.saveId = `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    entry.createdAt = now;
    saves.push(entry);
  }
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${teamId}`, JSON.stringify(saves));
  } catch {
    // localStorage full — silently fail
  }
  return entry;
}

export function deleteSave(teamId, saveId) {
  const saves = listSaves(teamId).filter((s) => s.saveId !== saveId);
  localStorage.setItem(`${STORAGE_PREFIX}${teamId}`, JSON.stringify(saves));
}

export function deleteSavesByType(teamId, saveType) {
  const saves = listSaves(teamId).filter((s) => s.saveType !== saveType);
  localStorage.setItem(`${STORAGE_PREFIX}${teamId}`, JSON.stringify(saves));
}
